// import { STATES } from 'common/domain/states';
import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';
import employeeAssembler from './employeeRepository.assemblers';

class EmployeeRepositoryService {

  constructor($http, $log, $window) {
    'ngInject';
    this.http = $http;
    this.log = $log;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  getEmployee(employeeProfileInfo) {
    return this.http.get(ENDPOINTS_LOANS.get.modalities(employeeProfileInfo.employeeId)).then(response => {
      const modalities = response.data.modalities;
      const employeeData = employeeProfileInfo;
      return employeeAssembler.assemble(employeeData, { modalities});
    }).catch(err => {
      this.log.error('EmployeeRepositoryService getEmployee() modalities', employeeProfileInfo, err);
      // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
      // this.state.go(STATES.ERROR);
    });
  }

}

export default EmployeeRepositoryService;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/employeeRepository/employeeRepository.service.js